<template>
  <div class="attestation-wrap">
    <h2>认证新企业/事业单位/社会组织</h2>
    <!-- <div class="right-tips">
      您提供的证件、信息等内容必须真实、准确、完整、及时、有效，如若因您提供的证件、信息等内容不满足真实、准确、完整、及时、有效条件而引致的各种损失或责任，均由您本人承担！！！
    </div> -->
    <div class="attestation-tips">
      请填写或提供以下信息材料，便于后台人员审核。
    </div>
    <el-form
      ref="form"
      :model="formData"
      label-width="200px"
      label-position="right"
      :rules="rules"
    >
      <el-form-item prop="name" label="企业/事业单位/社会组织名称">
        <el-input v-model="formData.name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item prop="number" label="统一社会信用代码">
        <el-input v-model="formData.number" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="" class="code-tips">
        <p>
          注：若有统一社会信用代码，请确认准确无误后输入；若无统一社会信用代码，请准确填入工商注册号！
        </p>
      </el-form-item>
      <el-form-item prop="realname" label="法人代表">
        <el-input v-model="formData.realname" placeholder=""></el-input>
      </el-form-item>
      <el-form-item prop="idcard" label="法人代表证件号码">
        <el-input v-model="formData.idcard" placeholder=""></el-input>
      </el-form-item>
      <el-form-item prop="address" label="地址">
        <el-row class="cascader">
          <el-col :xl="6">
            <el-cascader
              :options="address_options_provice"
              @change="provinceChange"
              :props="{
                value: 'id',
                label: 'fullName',
              }"
            ></el-cascader>
          </el-col>

          <el-col :xl="6">
            <el-cascader
              :options="address_options_city"
              @change="cityChange"
              :props="{
                value: 'id',
                label: 'fullName',
              }"
            ></el-cascader>
          </el-col>

          <el-col :xl="6">
            <el-cascader
              :options="address_options_area"
              @change="areaChange"
              :props="{
                value: 'id',
                label: 'fullName',
              }"
            ></el-cascader>
          </el-col>

          <el-col :xl="6">
            <el-cascader
              :options="address_options_county"
              @change="countyChange"
              :props="{
                value: 'id',
                label: 'fullName',
              }"
            ></el-cascader>
          </el-col>
        </el-row>
        <el-input
          style="margin-top: 10px"
          v-model="formData.address"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item prop="phone" label="固定电话">
        <el-input v-model="formData.phone" placeholder=""></el-input>
      </el-form-item>
      <el-form-item prop="businessimage" label="营业执照">
        <el-upload
          class="upload-demo"
          :action="action"
          :on-preview="handlePreview"
          :before-upload="beforeUpload"
          :on-success="onSuccess"
          :on-error="onError"
          :on-remove="handleRemove"
          :file-list="fileList"
          list-type="picture"
        >
          <el-button size="mini" type="primary">上传照片</el-button>
          <div slot="tip" class="el-upload__tip">
            支持jpg、png格式、大小不超过5MB
          </div>
        </el-upload>
      </el-form-item>
      <!--			<el-form-item prop="cardimage" label="企业名片">
              <el-upload class="upload-demo" :action="action" :on-preview="handlePreview2" :before-upload="beforeUpload2" :on-success="onSuccess2" :on-error="onError2"
                :on-remove="handleRemove2" :file-list="fileList2" list-type="picture">
                <el-button size="mini" type="primary">上传照片</el-button>
                <div slot="tip" class="el-upload__tip">支持jpg、png格式、大小不超过5MB</div>
              </el-upload>
            </el-form-item>
            <el-form-item prop="certimage" label="代理人授权书(加盖公章)">
              <el-upload class="upload-demo" :action="action" :on-preview="handlePreview3" :before-upload="beforeUpload3" :on-success="onSuccess3" :on-error="onError3"
                :on-remove="handleRemove3" :file-list="fileList3" list-type="picture">
                <el-button size="mini" type="primary">上传照片</el-button>
                <div slot="tip" class="el-upload__tip">支持jpg、png格式、大小不超过5MB</div>
              </el-upload>
            </el-form-item>-->
      <el-form-item>
        <div @click.stop="agreeMentChange">
          <input type="checkbox" :checked="isAgreement" />
          阅读并接受
          <div
            style="display: inline; color: cornflowerblue; cursor: pointer"
            type="text"
            @click.stop="dialogVisible = !dialogVisible"
          >
            《信用承诺书》
          </div>
        </div>
      </el-form-item>
      <el-dialog title="信用承诺书" :visible.sync="dialogVisible" width="30%">
        <span
          >本人郑重承诺，本人填报的信息准确无误，如有错误信息，信用评价等级将为C</span
        >
        <span slot="footer" class="dialog-footer"></span>
      </el-dialog>
      <el-form-item>
        <el-button
          type="primary"
          :disabled="!isAgreement"
          @click="confirmHandle"
          >提交信息</el-button
        >
        <el-button
          style="margin-left: 20px !important"
          type="warning"
          @click="reset"
          >取消</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import BASE_URL from "@/api/base.js";

import { enterpriseClaim, getAddressData } from "@/api";
export default {
  components: {},
  data() {
    return {
      action: BASE_URL + "api/file/upload",
      submitBtn: true,
      formData: {},
      isAgreement: false,
      // 地址选择
      // 省
      address_options_provice: [],
      // 市
      address_options_city: [],
      // 区
      address_options_area: [],
      // 县
      address_options_county: [],
      rules: {
        name: [{ required: true, message: "请填写企业/事业单位/社会组织名称" }],
        number: [{ required: true, message: "请填写统一社会信用代码" }],
        address: [{ required: true, message: "请填写详细地址" }],
        idcard: [{ required: true, message: "请填写法人代表证件号码" }],
        realname: [{ required: true, message: "请填写法人代表" }],
        phone: [{ required: true, message: "请填写固定电话" }],
        businessimage: [
          { required: true, message: "请上传营业执照", trigger: "change" },
        ],
      },
      fileList: [],
      fileList2: [],
      fileList3: [],
      dialogVisible: false,
    };
  },
  methods: {
    // 地址的回调
    // 省
    provinceChange(e) {
      this.getAddress({
        id: e[0],
        type: "province",
      });
      this.$set(this, "address_options_city", []);
      this.$set(this, "address_options_area", []);
      this.$set(this, "address_options_county", []);
    },
    // 市
    cityChange(e) {
      this.getAddress({
        id: e[0],
        type: "city",
      });
      this.$set(this, "address_options_area", []);
      this.$set(this, "address_options_county", []);
    },
    // 区
    areaChange(e) {
      this.getAddress({
        id: e[0],
        type: "area",
      });
      this.$set(this, "address_options_county", []);
    },
    //  县
    countyChange(e) {
      console.log(e);
    },
    agreeMentChange() {
      this.isAgreement = !this.isAgreement;
    },
    open() {
      this.submitBtn = false;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    beforeUpload(file) {},

    // 图片上传完成后的回调
    onSuccess(response, file, fileList) {
      const { result } = response;
      this.$set(this.formData, "businessimage", result);
    },
    onError() {},
    handleRemove2(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview2(file) {
      console.log(file);
    },
    beforeUpload2(file) {},
    onSuccess2(response, file, fileList) {
      const { result } = response;
      this.$set(this.formData, "cardimage", result);
    },
    onError2() {},
    handleRemove3(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview3(file) {
      console.log(file);
    },
    beforeUpload3(file) {},
    onSuccess3(response, file, fileList) {
      const { result } = response;
      this.$set(this.formData, "certimage", result);
    },
    onError3() {},

    confirmHandle() {
      if (!this.isAgreement) {
        return;
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          enterpriseClaim(this.formData).then((res) => {
            this.$message({
              message: "提交成功，请等待审核",
              type: "success",
            });
            this.reset();
          });
        }
      });
    },
    reset() {
      this.$refs["form"].resetFields();
      this.$set(this, "formData", {});
      this.$set(this, "fileList", []);
      this.$set(this, "fileList2", []);
      this.$set(this, "fileList3", []);
      this.$set(this, "address_options_provice", []);
      this.$set(this, "address_options_city", []);
      this.$set(this, "address_options_area", []);
      this.$set(this, "address_options_county", []);
    },

    // 获取省市区
    getAddress(options) {
      console.log(options);
      getAddressData(options.id || "-1").then((val) => {
        switch (options.type) {
          case "province":
            this.$set(this, "address_options_city", val.list);
            break;
          case "city":
            this.$set(this, "address_options_area", val.list);
            break;
          case "area":
            this.$set(this, "address_options_county", val.list);
            break;
          default:
            this.$set(this, "address_options_provice", val.list);
            break;
        }
      });
    },
  },

  mounted() {
    this.getAddress({ id: "-1", type: "add" });
  },
};
</script>
<style lang="scss">
.attestation-wrap {
  padding: 22px 18px;
  text-align: left;
  position: relative;

  .right-tips {
    position: absolute;
    top: 40px;
    right: 0;
    width: 250px;
    line-height: 28px;
    padding: 0 0 0 21px;
    color: $red;
    border-left: 2px solid $red;
  }

  & > h2 {
    color: $red;
  }

  & > .attestation-tips {
    margin: 35px 0 20px;
    text-align: center;
    color: #686868;
  }

  .el-input {
    height: 40px;

    .el-input__inner {
      height: 40px;
      border-radius: 3px;
      border: 1px solid #e3d7ea;
    }
  }
  .el-button {
    margin: 0 !important;
  }
  .code-tips {
    color: #686868;
    margin-bottom: 10px;
  }

  .el-button {
    width: 100px;
    margin: 0 20px;

    &:not(.el-button--warning) {
      background-color: $red;
      border-color: $red;
    }
  }

  .el-upload-list__item {
    width: 500px;
  }

  .cascader {
    width: 500px;
    .el-input {
      width: 100% !important;
    }
  }
}
</style>
